<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Card',
});
</script>

<template>
  <div class="px-4 py-5 bg-white border border-gray-300 border-solid rounded-2xl md:px-8 md:py-10">
    <slot />
  </div>
</template>
